/* istanbul ignore file */
import DealerspikeV7 from '../platform/dealerspike-v7';

new DealerspikeV7().init();
